import { Image } from '@chakra-ui/react';
import { getAssetUrl } from '@cronos-app/chakra';
import { ADDRESS_BY_CHAIN_L2, getRelatedL2Chain } from '@cronos-app/sdk';

import { Token } from '../model';
import type { TokenRegister } from './types';

export const getVUsdToken: TokenRegister = (desiredNetwork) => {
  return {
    type: Token.vUSD,
    symbol: 'vUSD',
    addressL1: '',
    addressL2: ADDRESS_BY_CHAIN_L2[getRelatedL2Chain(desiredNetwork)].ZkUSD,
    addressCronosEvm: '',
    decimals: 18,
    displayDecimals: 2,
    Icon: (props) => (
      <Image
        src={getAssetUrl('/tokens/vusd.svg')}
        boxSize="24px"
        // eslint-disable-next-line @ts-intl/ts-intl/no-raw-text
        alt="vUSD"
        {...props}
      />
    ),
  };
};
